if (!customElements.get('bundle-tiers')) {
  customElements.define(
    'bundle-tiers',
    class BundleTiers extends HTMLElement {
      connectedCallback() {
        this.quantityInput = this.querySelector('[data-bundle-quantity]');
        this.radios = Array.from(this.querySelectorAll('.bundle-tiers__input'));
        this.onChange = this.syncQuantity.bind(this);
        this.radios.forEach((radio) => radio.addEventListener('change', this.onChange));
        this.syncQuantity();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const data = event?.data;
            if (!data || data.sectionId !== this.dataset.section || !data.variant) return;
            this.updatePrices(data.variant.price);
          });
        }
      }

      disconnectedCallback() {
        this.radios?.forEach((radio) => radio.removeEventListener('change', this.onChange));
        this.variantChangeUnsubscriber?.();
      }

      get selectedRadio() {
        return this.radios.find((radio) => radio.checked) || this.radios[0];
      }

      syncQuantity() {
        const radio = this.selectedRadio;
        if (!radio || !this.quantityInput) return;
        this.quantityInput.value = radio.value;
        this.dispatchEvent(
          new CustomEvent('bundle-tiers:change', {
            bubbles: true,
            detail: { quantity: parseInt(radio.value, 10) },
          })
        );
      }

      updatePrices(unitCents) {
        const price = parseInt(unitCents, 10);
        if (Number.isNaN(price)) return;

        this.radios.forEach((radio) => {
          const card = radio.nextElementSibling;
          if (!card) return;
          const qty = parseInt(radio.value, 10) || 1;
          const percentOff = parseFloat(radio.dataset.percentOff) || 0;
          const amountOffCents = parseInt(radio.dataset.amountOffCents, 10) || 0;
          const compareCents = price * qty;
          let unit = price;
          let total = compareCents;

          if (amountOffCents > 0) {
            unit = Math.max(price - amountOffCents, 0);
            total = unit * qty;
          } else if (percentOff > 0) {
            unit = Math.max(price - Math.floor((price * percentOff) / 100 + 0.0001), 0);
            total = unit * qty;
          }

          const save = compareCents - total;
          const savePercent =
            percentOff > 0 && amountOffCents <= 0
              ? percentOff
              : compareCents > 0
              ? Math.floor((save * 100) / compareCents)
              : 0;
          const setText = (selector, text) => {
            const el = card.querySelector(selector);
            if (el) el.textContent = text;
          };

          setText('[data-unit]', this.formatMoney(unit));
          setText('[data-total]', this.formatMoney(total));
          setText('[data-compare]', this.formatMoney(compareCents));
          const saveText =
            this.dataset.savingsFormat === 'percent'
              ? (this.dataset.savePercent || '').replace('[percent]', savePercent)
              : (this.dataset.saveAmount || '').replace('[amount]', this.formatMoney(save));
          setText('[data-save]', saveText);
          card.querySelector('.bundle-tiers__compare')?.toggleAttribute('hidden', save <= 0);
          card.querySelector('[data-save]')?.toggleAttribute('hidden', save <= 0);
        });
      }

      formatMoney(cents) {
        const format = this.dataset.moneyFormat || '${{amount}}';
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const type = match ? match[1] : 'amount';
        const group = (decimals, thousands, decimal) => {
          const [whole, fraction] = (cents / 100).toFixed(decimals).split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return fraction ? grouped + decimal + fraction : grouped;
        };
        const formats = {
          amount: () => group(2, ',', '.'),
          amount_no_decimals: () => group(0, ',', '.'),
          amount_with_comma_separator: () => group(2, '.', ','),
          amount_no_decimals_with_comma_separator: () => group(0, '.', ','),
          amount_with_apostrophe_separator: () => group(2, "'", '.'),
          amount_with_space_separator: () => group(2, ' ', ','),
        };
        const value = (formats[type] || formats.amount)();
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      }
    }
  );
}
